import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';
import { LearnosityTestType, TestResultDto, TestStatus } from '../../shared/types/TestResultDto';

@Component({
  selector: 'lp2-test-result-tile',
  templateUrl: './test-result-tile.component.html',
  styleUrls: ['./test-result-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestResultTileComponent implements OnChanges {
  @Input() testResult: TestResultDto;
  levelNumber: number;
  learnosityTestType = LearnosityTestType;
  TestStatus = TestStatus;

  constructor() { }

  ngOnChanges() {
    this.levelNumber = +this.testResult.level.name.split(' ')[1];
    this.testResult.lastUpdatedDate = new Date(this.testResult.lastUpdatedDate);
  }

}



// WEBPACK FOOTER //
// ./ts/app/test-results/test-result-tile/test-result-tile.component.ts